<template>
  <v-app>
    <Navbar v-if="isLoggedIn || $route.name === 'beranda'" />
    <v-main :class="{ 'green-dark-background': greenDarkBackground }">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
const Navbar = () => import('@/components/Navbar');
import pushNotif from '@/mixins/pushNotif';
export default {
  name: 'App',
  mixins: [pushNotif],
  components: {
    Navbar
  },
  created() {
    if ('Notification' in window && 'serviceWorker' in navigator) {
      this.tokenFirebase();
    }
  },
  watch: {
    $route: {
      handler(val) {
        window.scrollTo(0, 0);
        if (val.name !== 'login') {
          if ('Notification' in window && 'serviceWorker' in navigator) {
            this.tokenFirebase();
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
    greenDarkBackground() {
      const route = this.$route.name;
      const routes = ['login', 'menu', '404', '500', '401'];
      if (routes.includes(route)) {
        return true;
      }
      return false;
    }
  },
  data: () => ({
    //
  })
};
</script>
